import AssessmentEnginePage from '@/pages/admin/assessment-engine-page'

export function SettingsAssessmentEnginePage() {
    return <AssessmentEnginePage />
}
